import {
  ChildLaborKey,
  ChildLaborLabel,
  FreedomOfAssociationAndCollectiveBargainingKey,
  NonDiscriminationKey,
  NonDiscriminationLabel,
  DiversityOfGovernanceBodiesAndEmployeesKey,
  DiversityOfGovernanceBodiesAndEmployeesLabel,
  EmploymentKey,
  EmploymentLabel,
  FreedomOfAssociationAndCollectiveBargainingLabel,
  HumanRightsAssessmentKey,
  HumanRightsAssessmentLabel,
  LaborManagementRelationsKey,
  LaborManagementRelationsLabel,
  LocalCommunitiesKey,
  LocalCommunitiesLabel,
  MarketPresenceKey,
  MarketPresenceLabel,
  RatioOfBasicSalaryAndRemunerationOfWomenToMenKey,
  RatioOfBasicSalaryAndRemunerationOfWomenToMenLabel,
  RightsOfIndigenousPeoplesKey,
  RightsOfIndigenousPeoplesLabel,
  SecurityPracticesKey,
  SecurityPracticesLabel,
  ForcedLaborLabel,
  ForcedLaborKey,
  OccupationalHealthAndSafetyLabel,
  OccupationalHealthAndSafetyKey,
  WorkRelatedIllHealthLabel,
  WorkRelatedIllHealthKey,
  WorkRelatedInjuriesKey,
  WorkRelatedInjuriesLabel,
  TrainingAndEducationLabel,
  TrainingAndEducationKey,
  SupplierSocialAssessmentLabel,
  SupplierSocialAssessmentKey,
  CustomerHealthAndSafetyLabel,
  CustomerHealthAndSafetyKey,
  CustomerPrivacyLabel,
  SocioeconomicComplianceLabel,
  SocioeconomicComplianceKey,
  CustomerPrivacyKey
} from '../../../../components/Forms/Constants/Social/QuestionsKeyLabel';
import {inputType} from '../../interface/inputType';

/* eslint-disable max-len */
export const diversityOfGovernanceBodiesAndEmployeesTabQuestions = [
  {
    key: '1',
    label: DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_1,
    kpiId: '405-1',
    items: [
      {
        question: 'i. Gender:',
        tooltip:
          'This disclosure provides a quantitative measure of diversity within an organization and can be used in conjunction with sectoral or regional benchmarks. Comparisons between broad employee diversity and management team diversity offer information on equal opportunity. Information reported in this disclosure also helps in assessing which issues can be of particular relevance to certain segments of the governance bodies or employees.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_1,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_2,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_3,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_4,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_4
          }
        ]
      },
      {
        question: 'ii. Age group: ',
        tooltip:
          'This disclosure provides a quantitative measure of diversity within an organization and can be used in conjunction with sectoral or regional benchmarks. Comparisons between broad employee diversity and management team diversity offer information on equal opportunity. Information reported in this disclosure also helps in assessing which issues can be of particular relevance to certain segments of the governance bodies or employees.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_5,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_6,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_7,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_8,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_8
          },
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_9,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_10,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_10
          }
        ]
      },
      {
        question:
          'iii. Other indicators of diversity where relevant (such as minority or vulnerable groups).',
        tooltip:
          'This disclosure provides a quantitative measure of diversity within an organization and can be used in conjunction with sectoral or regional benchmarks. Comparisons between broad employee diversity and management team diversity offer information on equal opportunity. Information reported in this disclosure also helps in assessing which issues can be of particular relevance to certain segments of the governance bodies or employees.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_11,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_11
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_12,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_12
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_2,
    kpiId: '405-1',
    items: [
      {
        question: 'i. Gender: ',
        tooltip:
          'This disclosure provides a quantitative measure of diversity within an organization and can be used in conjunction with sectoral or regional benchmarks. Comparisons between broad employee diversity and management team diversity offer information on equal opportunity. Information reported in this disclosure also helps in assessing which issues can be of particular relevance to certain segments of the governance bodies or employees.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_13,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_14,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_19
          },
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_15,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_16,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_19
          }
        ]
      },
      {
        question: 'ii. Age group: ',
        tooltip:
          'This disclosure provides a quantitative measure of diversity within an organization and can be used in conjunction with sectoral or regional benchmarks. Comparisons between broad employee diversity and management team diversity offer information on equal opportunity. Information reported in this disclosure also helps in assessing which issues can be of particular relevance to certain segments of the governance bodies or employees.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_17,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_18,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_19
          },
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_19,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_20,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_19
          },
          {
            fieldType: inputType.HEADING,
            heading:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_HEADING_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_21,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_17
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_22,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_19
          }
        ]
      },
      {
        question:
          'iii. Other indicators of diversity where relevant (such as minority or vulnerable groups).',
        tooltip:
          'This disclosure provides a quantitative measure of diversity within an organization and can be used in conjunction with sectoral or regional benchmarks. Comparisons between broad employee diversity and management team diversity offer information on equal opportunity. Information reported in this disclosure also helps in assessing which issues can be of particular relevance to certain segments of the governance bodies or employees.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_23,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_18
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              DiversityOfGovernanceBodiesAndEmployeesKey.DOGBE_QUESTION_24,
            fieldLabel:
              DiversityOfGovernanceBodiesAndEmployeesLabel.DOGBE_QUESTION_19
          }
        ]
      }
    ]
  }
];

export const ratioOfBasicSalaryAndRemunerationOfWomenToMenTabQuestions = [
  {
    key: '1',
    label: RatioOfBasicSalaryAndRemunerationOfWomenToMenLabel.ROBSAROWTM_1,
    kpiId: '405-2',
    items: [
      {
        question:
          'a. Ratio of the basic salary and remuneration of women to men for each employee category, by significant locations of operation.',
        tooltip:
          'The reporting organization can draw from the information used for Disclosure 405-1 to identify the total number of employees in each employee category by gender.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName:
              RatioOfBasicSalaryAndRemunerationOfWomenToMenKey.ROBSAROWTM_QUESTION_1,
            fieldLabel:
              RatioOfBasicSalaryAndRemunerationOfWomenToMenLabel.ROBSAROWTM_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              RatioOfBasicSalaryAndRemunerationOfWomenToMenKey.ROBSAROWTM_QUESTION_2,
            fieldLabel:
              RatioOfBasicSalaryAndRemunerationOfWomenToMenLabel.ROBSAROWTM_QUESTION_2
          }
        ]
      },
      {
        question:
          'b. The definition used for ‘significant locations of operation',
        tooltip:
          'The reporting organization can draw from the information used for Disclosure 405-1 to identify the total number of employees in each employee category by gender.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              RatioOfBasicSalaryAndRemunerationOfWomenToMenKey.ROBSAROWTM_QUESTION_3,
            fieldLabel:
              RatioOfBasicSalaryAndRemunerationOfWomenToMenLabel.ROBSAROWTM_QUESTION_3
          }
        ]
      }
    ]
  }
];

export const employmentTabQuestions = [
  {
    key: '1',
    label: EmploymentLabel.E_EMPLOYMENT_1,
    kpiId: '401-1',
    items: [
      {
        question: 'a. New employee hires :',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_3,
            tooltip:
              'New employee hired in the reporting period shall be classified as following:An organization can use the following age groups: • Under 30 years old. • 30-50 years old. • Over 50 years old.'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_1,
            fieldLabel: EmploymentLabel.E_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_2,
            fieldLabel: EmploymentLabel.E_QUESTION_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_3,
            fieldLabel: EmploymentLabel.E_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_4,
            tooltip:
              'New employee hired in the reporting period shall be classified as following:male , female/ men, women'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_4,
            fieldLabel: EmploymentLabel.E_QUESTION_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_5,
            fieldLabel: EmploymentLabel.E_QUESTION_5
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_5,
            tooltip:
              'New employee hired in the reporting period shall be classified as following: Asia, APAC, North America, South America, Europe'
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'newEmployeeHiresByRegion',
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName: EmploymentKey.E_QUESTION_6,
                  fieldLabel: EmploymentLabel.E_QUESTION_6
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_6
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_3,
            tooltip:
              'New employee hired in the reporting period shall be classified as following: An organization can use the following age groups: • Under 30 years old. • 30-50 years old. • Over 50 years old.'
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_7,
            fieldLabel: EmploymentLabel.E_QUESTION_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_8,
            fieldLabel: EmploymentLabel.E_QUESTION_8
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_9,
            fieldLabel: EmploymentLabel.E_QUESTION_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_10,
            fieldLabel: EmploymentLabel.E_QUESTION_10
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_11,
            fieldLabel: EmploymentLabel.E_QUESTION_11
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_12,
            fieldLabel: EmploymentLabel.E_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_4,
            tooltip:
              'New employee hired in the reporting period shall be classified as following: male , female/ men, women'
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_13,
            fieldLabel: EmploymentLabel.E_QUESTION_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_14,
            fieldLabel: EmploymentLabel.E_QUESTION_14
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_15,
            fieldLabel: EmploymentLabel.E_QUESTION_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_16,
            fieldLabel: EmploymentLabel.E_QUESTION_16
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_5,
            tooltip:
              'New employee hired in the reporting period shall be classified as following: Asia, APAC, North America, South America, Europe'
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'rateOfNewEmployeeHiresByRegion',
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName: EmploymentKey.E_QUESTION_17,
                  fieldLabel: EmploymentLabel.E_QUESTION_17
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EmploymentKey.E_QUESTION_18,
                  fieldLabel: EmploymentLabel.E_QUESTION_18
                }
              ]
            }
          }
        ]
      },
      {
        question: 'b. Total number of employee turnover :',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_3,
            tooltip:
              'Total number and rate of employee turnover in the reporting period shall be classified as following: An organization can use the following age groups: • Under 30 years old. • 30-50 years old. • Over 50 years old.'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_19,
            fieldLabel: EmploymentLabel.E_QUESTION_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_20,
            fieldLabel: EmploymentLabel.E_QUESTION_20
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_21,
            fieldLabel: EmploymentLabel.E_QUESTION_21
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_4,
            tooltip:
              'Total number and rate of employee turnover in the reporting period shall be classified as following: male, female/ men, women'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_28,
            fieldLabel: EmploymentLabel.E_QUESTION_28
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_29,
            fieldLabel: EmploymentLabel.E_QUESTION_29
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_5,
            tooltip:
              'New employee hired in the reporting period shall be classified as following: Asia, APAC, North America, South America, Europe'
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'rateOfNewEmployeeTurnoverByRegion',
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName: EmploymentKey.E_QUESTION_34,
                  fieldLabel: EmploymentLabel.E_QUESTION_34
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_10
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_3,
            tooltip:
              'Total number and rate of employee turnover in the reporting period shall be classified as following: An organization can use the following age groups: • Under 30 years old. • 30-50 years old. • Over 50 years old.'
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_22,
            fieldLabel: EmploymentLabel.E_QUESTION_22
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_23,
            fieldLabel: EmploymentLabel.E_QUESTION_23
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_24,
            fieldLabel: EmploymentLabel.E_QUESTION_24
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_25,
            fieldLabel: EmploymentLabel.E_QUESTION_25
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_26,
            fieldLabel: EmploymentLabel.E_QUESTION_26
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_27,
            fieldLabel: EmploymentLabel.E_QUESTION_27
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_4,
            tooltip:
              'Total number and rate of employee turnover in the reporting period shall be classified as following: male, female/ men, women'
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_30,
            fieldLabel: EmploymentLabel.E_QUESTION_30
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_31,
            fieldLabel: EmploymentLabel.E_QUESTION_31
          },
          {
            fieldType: inputType.HEADING_5,
            heading: EmploymentLabel.E_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_32,
            fieldLabel: EmploymentLabel.E_QUESTION_32
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_33,
            fieldLabel: EmploymentLabel.E_QUESTION_33
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_5,
            tooltip:
              'Total number and rate of employee turnover in the reporting period shall be classified as following: Asia, APAC, North America, South America, Europe'
          },
          {
            fieldType: inputType.ADD_MORE_FIELDS,
            formList: {
              name: 'rateOfEmployeeTurnoverByRegion',
              formFields: [
                {
                  type: inputType.NUMBER,
                  fieldName: EmploymentKey.E_QUESTION_35,
                  fieldLabel: EmploymentLabel.E_QUESTION_35
                },
                {
                  type: inputType.NUMBER,
                  fieldName: EmploymentKey.E_QUESTION_36,
                  fieldLabel: EmploymentLabel.E_QUESTION_36
                }
              ]
            }
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_11,
            tooltip:
              'Total turnover in the reporting period Voluntary+ Involuntary'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_37,
            fieldLabel: EmploymentLabel.E_QUESTION_37
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_38,
            fieldLabel: EmploymentLabel.E_QUESTION_38
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: EmploymentLabel.E_EMPLOYMENT_2,
    kpiId: '401-2',
    items: [
      {
        question:
          'Benefits provided to full-time employees that are not provided to temporary or part-time employees',
        tooltip:
          'a. Benefits which are standard for full-time employees of the organization but are not provided to temporary or part-time employees, by significant locations of operation. These include, as a minimum: i. life insurance. ii. health care. iii. disability and invalidity coverage. iv. parental leave. v. retirement provision. vi. stock ownership. vii. others. b. The definition used for ‘significant locations of operation’',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: EmploymentKey.E_QUESTION_39,
            fieldLabel: EmploymentLabel.E_QUESTION_39
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: EmploymentLabel.E_EMPLOYMENT_3,
    kpiId: '401-3',
    items: [
      {
        question:
          'a. Total number of employees that were entitled to parental leave, by gender.',
        tooltip: 'By gender. As Male, Female/ Men, Women',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_40,
            fieldLabel: EmploymentLabel.E_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_41,
            fieldLabel: EmploymentLabel.E_LABEL_2
          }
        ]
      },
      {
        question:
          'b. Total number of employees that took parental leave, by gender.',
        tooltip:
          'Male and female who took parental leave for the reporting period',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_42,
            fieldLabel: EmploymentLabel.E_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_43,
            fieldLabel: EmploymentLabel.E_LABEL_2
          }
        ]
      },
      {
        question:
          'c. Total number of employees that returned to work in the reporting period after parental leave ended, by gender.',
        tooltip: 'The employees returned to work afterk parental leave ended',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_44,
            fieldLabel: EmploymentLabel.E_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_45,
            fieldLabel: EmploymentLabel.E_LABEL_2
          }
        ]
      },
      {
        question:
          'd. Total number of employees that returned to work after parental leave ended that were still employed 12 months after their return to work, by gender',
        tooltip: 'By gender. As Male, Female/ Men, Women',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_46,
            fieldLabel: EmploymentLabel.E_LABEL_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_47,
            fieldLabel: EmploymentLabel.E_LABEL_2
          }
        ]
      },
      {
        question:
          'e. Return to work rates of employees that took parental leave, by gender: ',
        tooltip: 'By gender. As Male, Female/ Men, Women',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_48,
            fieldLabel: EmploymentLabel.E_QUESTION_48
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_49,
            fieldLabel: EmploymentLabel.E_QUESTION_49
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_50,
            fieldLabel: EmploymentLabel.E_QUESTION_50
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_51,
            fieldLabel: EmploymentLabel.E_QUESTION_51
          }
        ]
      },
      {
        question:
          'f. Retention to work rates of employees that took parental leave, by gender: ',
        tooltip: 'By gender. As Male, Female/ Men, Women',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_52,
            fieldLabel: EmploymentLabel.E_QUESTION_52
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_53,
            fieldLabel: EmploymentLabel.E_QUESTION_53
          },
          {
            fieldType: inputType.HEADING,
            heading: EmploymentLabel.E_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_54,
            fieldLabel: EmploymentLabel.E_QUESTION_54
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: EmploymentKey.E_QUESTION_55,
            fieldLabel: EmploymentLabel.E_QUESTION_55
          }
        ]
      }
    ]
  }
];

export const laborManagementRelationsTabQuestions = [
  {
    key: '1',
    label: LaborManagementRelationsLabel.LMR_LABOR_MANAGEMENT_RELATIONS_1,
    kpiId: '402-1',
    items: [
      {
        question:
          'a. Minimum number of weeks’ notice typically provided to employees and their representatives prior to the implementation of significant operational changes that could substantially affect them.',
        tooltip:
          'Minimum notice periods can be found in corporate policies and standard employment contracts. Different policy statements can exist at a regional level.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: LaborManagementRelationsKey.LMR_QUESTION_1,
            fieldLabel: LaborManagementRelationsLabel.LMR_QUESTION_1
          }
        ]
      },
      {
        question:
          'b. For organizations with collective bargaining agreements, report whether the notice period and provisions for consultation and negotiation are specified in collective agreements.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: LaborManagementRelationsKey.LMR_QUESTION_2,
            fieldLabel: LaborManagementRelationsLabel.LMR_QUESTION_2
          }
        ]
      }
    ]
  }
];

export const securityPracticesTabQuestions = [
  {
    key: '1',
    label: SecurityPracticesLabel.SP_SECURITY_PRACTICES_1,
    kpiId: '410-1',
    items: [
      {
        question:
          'a. Percentage of security personnel who have received formal training in the organization’s human rights policies or specific procedures and their application to security.',
        tooltip:
          'The training can refer either to training dedicated to the subject of human rights or to a human rights module within a general training program. Training can cover issues such as the use of force, inhuman or degrading treatment or discrimination, or identification and registering.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SecurityPracticesKey.SP_QUESTION_1,
            fieldLabel: SecurityPracticesLabel.SP_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SecurityPracticesKey.SP_QUESTION_2,
            fieldLabel: SecurityPracticesLabel.SP_QUESTION_2
          }
        ]
      },
      {
        question:
          'b. Whether training requirements also apply to third-party organizations providing security personnel.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: SecurityPracticesKey.SP_QUESTION_3,
            fieldLabel: SecurityPracticesLabel.SP_QUESTION_3
          }
        ]
      }
    ]
  }
];

export const rightsOfIndigenousPeoplesTabQuestions = [
  {
    key: '1',
    label: RightsOfIndigenousPeoplesLabel.ROIP_RIGHTS_OF_INDIGENOUS_PEOPLES_1,
    kpiId: '411-1',
    items: [
      {
        question:
          'a. Total number of identified incidents of violations involving the rights of indigenous peoples during the reporting period.',
        tooltip:
          'In the context of this disclosure, an ‘incident’ refers to a legal action or complaint registered with the reporting organization or competent authorities through a formal process, or an instance of non-compliance identified by the organization through established procedures. Established procedures to identify instances of noncompliance can include management system audits, formal monitoring programs, or grievance mechanisms',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: RightsOfIndigenousPeoplesKey.ROIP_QUESTION_1,
            fieldLabel: RightsOfIndigenousPeoplesLabel.ROIP_QUESTION_1
          }
        ]
      },
      {
        question:
          'b. Status of the incidents and actions taken with reference to the following: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: RightsOfIndigenousPeoplesLabel.ROIP_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: RightsOfIndigenousPeoplesKey.ROIP_QUESTION_2,
            fieldLabel: RightsOfIndigenousPeoplesLabel.ROIP_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: RightsOfIndigenousPeoplesLabel.ROIP_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: RightsOfIndigenousPeoplesKey.ROIP_QUESTION_3,
            fieldLabel: RightsOfIndigenousPeoplesLabel.ROIP_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: RightsOfIndigenousPeoplesLabel.ROIP_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: RightsOfIndigenousPeoplesKey.ROIP_QUESTION_4,
            fieldLabel: RightsOfIndigenousPeoplesLabel.ROIP_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: RightsOfIndigenousPeoplesLabel.ROIP_HEADING_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: RightsOfIndigenousPeoplesKey.ROIP_QUESTION_5,
            fieldLabel: RightsOfIndigenousPeoplesLabel.ROIP_QUESTION_5
          }
        ]
      }
    ]
  }
];

export const humanRightsAssessmentTabQuestions = [
  {
    key: '1',
    label: HumanRightsAssessmentLabel.HRA_HUMAN_RIGHTS_ASSESSMENT_1,
    kpiId: '412-1',
    items: [
      {
        question:
          'a. Total number of operations that have been subject to human rights reviews or human rights impact assessments, by country.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_1,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: HumanRightsAssessmentLabel.HRA_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_2,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_3,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: HumanRightsAssessmentLabel.HRA_HUMAN_RIGHTS_ASSESSMENT_2,
    kpiId: '412-2',
    items: [
      {
        question:
          'a. Total number of hours in the reporting period devoted to training on human rights policies  or procedures concerning aspects of human rights that are relevant to operations.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_4,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_4
          }
        ]
      },
      {
        question:
          'b. Percentage of employees trained during the reporting period in human rights policies or procedures concerning aspects of human rights that are relevant to operations',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_5,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_6,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_6
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: HumanRightsAssessmentLabel.HRA_HUMAN_RIGHTS_ASSESSMENT_3,
    kpiId: '412-3',
    items: [
      {
        question:
          'a. Total number of significant investment agreements and contracts that include human rights clauses or that underwent human rights screening',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_7,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_7
          },
          {
            fieldType: inputType.HEADING,
            heading: HumanRightsAssessmentLabel.HRA_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_8,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_9,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_9
          }
        ]
      },
      {
        question:
          'b. The definition used for ‘significant investment agreements’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: HumanRightsAssessmentKey.HRA_QUESTION_10,
            fieldLabel: HumanRightsAssessmentLabel.HRA_QUESTION_10
          }
        ]
      }
    ]
  }
];

export const localCommunitiesTabQuestions = [
  {
    key: '1',
    label: LocalCommunitiesLabel.LC_LOCAL_COMMUNITIES_1,
    kpiId: '413-1',
    items: [
      {
        headings: [
          {
            headingType: inputType.HEADING_3,
            heading: LocalCommunitiesLabel.LC_HEADING_1
          }
        ],
        question:
          'a. Percentage of operations with implemented local community engagement, impact assessments, and/or development programs, including the use of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_2
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_1
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_3
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_3
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_4
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_4
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_5
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_6
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_5
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_7
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_8
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_6
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_9
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_10
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_10
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_7
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_11
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_11
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_12
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_8
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_13
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_13
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_14
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_9
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_15
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_15
          },
          {
            fieldType: inputType.HEADING_5,
            heading: LocalCommunitiesLabel.LC_QUESTION_16
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: LocalCommunitiesKey.LC_QUESTION_16
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: LocalCommunitiesLabel.LC_LOCAL_COMMUNITIES_2,
    kpiId: '413-2',
    items: [
      {
        question:
          'a. Operations with significant actual and potential negative impacts on local communities, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_10
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: LocalCommunitiesKey.LC_QUESTION_17,
            fieldLabel: LocalCommunitiesLabel.LC_QUESTION_17
          },
          {
            fieldType: inputType.HEADING,
            heading: LocalCommunitiesLabel.LC_HEADING_11
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: LocalCommunitiesKey.LC_QUESTION_18,
            fieldLabel: LocalCommunitiesLabel.LC_QUESTION_18
          }
        ]
      }
    ]
  }
];

export const marketPresenceTabQuestions = [
  {
    key: '1',
    label: MarketPresenceLabel.MP_MARKET_PRESENCE_1,
    kpiId: '202-1',
    items: [
      {
        question:
          'a. When a significant proportion of employees are compensated based on wages subject to minimum wage rules, report the relevant ratio of the entry level wage by gender at significant locations of operation to the minimum wage.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketPresenceKey.MP_QUESTION_1,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketPresenceKey.MP_QUESTION_2,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_2
          }
        ]
      },
      {
        question:
          'b. When a significant proportion of other workers (excluding employees) performing the organization’s activities are compensated based on wages subject to minimum wage rules, describe the actions taken to determine whether these workers are paid above the minimum wage.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketPresenceKey.MP_QUESTION_3,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_3
          }
        ]
      },
      {
        question:
          'c. Whether a local minimum wage is absent or variable at significant locations of operation, by gender. In circumstances in which different minimums can be used as a reference, report which minimum wage is being used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketPresenceKey.MP_QUESTION_4,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_4
          }
        ]
      },
      {
        question:
          'd. The definition used for ‘significant locations of operation’.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketPresenceKey.MP_QUESTION_5,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_5
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: MarketPresenceLabel.MP_MARKET_PRESENCE_2,
    kpiId: '202-2',
    items: [
      {
        question:
          'a. Percentage of senior management at significant locations of operation that are hired from the local community',
        tooltip:
          'Senior management hired from the local community includes those individuals either born or who have the legal right to reside indefinitely (such as naturalized citizens or permanent visa holders) in the same geographic market as the operation. The geographical definition of ‘local’ can include the community surrounding operations, a region within a country, or a country.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketPresenceKey.MP_QUESTION_6,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: MarketPresenceKey.MP_QUESTION_7,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_7
          }
        ]
      },
      {
        question: 'b. The definition used for ‘senior management’',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketPresenceKey.MP_QUESTION_8,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_8
          }
        ]
      },
      {
        question: 'c. The organization’s geographical definition of ‘local’',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketPresenceKey.MP_QUESTION_9,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_9
          }
        ]
      },
      {
        question:
          'd. The definition used for ‘significant locations of operation’',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: MarketPresenceKey.MP_QUESTION_10,
            fieldLabel: MarketPresenceLabel.MP_QUESTION_10
          }
        ]
      }
    ]
  }
];

export const freedomOfAssociationAndCollectiveBargainingTabQuestions = [
  {
    key: '1',
    label: FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_1,
    kpiId: '407-1',
    items: [
      {
        question:
          'a. Operations in which workers’ rights to exercise freedom of association or collective bargaining may be violated or at significant risk either in terms of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              FreedomOfAssociationAndCollectiveBargainingKey.FOACB_QUESTION_1,
            fieldLabel:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              FreedomOfAssociationAndCollectiveBargainingKey.FOACB_QUESTION_2,
            fieldLabel:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_QUESTION_2
          }
        ]
      },
      {
        question:
          'b. Measures taken by the organization in the reporting period intended to support rights to exercise freedom of association and collective bargaining.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              FreedomOfAssociationAndCollectiveBargainingKey.FOACB_QUESTION_3,
            fieldLabel:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_QUESTION_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_2,
    kpiId: '407-1',
    items: [
      {
        question:
          'a. Suppliers in which workers’ rights to exercise freedom of association or collective bargaining may be violated or at significant risk either in terms of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              FreedomOfAssociationAndCollectiveBargainingKey.FOACB_QUESTION_4,
            fieldLabel:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              FreedomOfAssociationAndCollectiveBargainingKey.FOACB_QUESTION_5,
            fieldLabel:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_QUESTION_5
          }
        ]
      },
      {
        question:
          'b. Measures taken by the organization in the reporting period intended to support rights to exercise freedom of association and collective bargaining.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName:
              FreedomOfAssociationAndCollectiveBargainingKey.FOACB_QUESTION_6,
            fieldLabel:
              FreedomOfAssociationAndCollectiveBargainingLabel.FOACB_QUESTION_6
          }
        ]
      }
    ]
  }
];

export const nonDiscriminationTabQuestions = [
  {
    key: '1',
    label: NonDiscriminationLabel.ND_NON_DISCRIMINATION_1,
    kpiId: '406-1',
    items: [
      {
        question:
          'a. Total number of incidents of discrimination during the reporting period.',
        tooltip:
          'In the context of this disclosure, an ‘incident’ refers to a legal action or complaint registered with the reporting organization or competent authorities through a formal process, or an instance of non-compliance identified by the organization through established procedures. Established procedures to identify instances of noncompliance can include management system audits, formal monitoring programs, or grievance mechanisms. An incident is no longer subject to action if it is resolved, the case is completed, or no further action is required by the organization. For example, an incident for which no further action is required can include cases that were withdrawn or where the underlying circumstances that led to the incident no longer exist.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: NonDiscriminationKey.ND_QUESTION_1,
            fieldLabel: NonDiscriminationLabel.ND_QUESTION_1
          }
        ]
      },
      {
        question: 'b. Status of the incidents and actions taken : ',
        tooltip:
          'In the context of this disclosure, an ‘incident’ refers to a legal action or complaint registered with the reporting organization or competent authorities through a formal process, or an instance of non-compliance identified by the organization through established procedures. Established procedures to identify instances of noncompliance can include management system audits, formal monitoring programs, or grievance mechanisms. An incident is no longer subject to action if it is resolved, the case is completed, or no further action is required by the organization. For example, an incident for which no further action is required can include cases that were withdrawn or where the underlying circumstances that led to the incident no longer exist.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: NonDiscriminationLabel.ND_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: NonDiscriminationKey.ND_QUESTION_2,
            fieldLabel: NonDiscriminationLabel.ND_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: NonDiscriminationLabel.ND_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: NonDiscriminationKey.ND_QUESTION_3,
            fieldLabel: NonDiscriminationLabel.ND_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: NonDiscriminationLabel.ND_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: NonDiscriminationKey.ND_QUESTION_4,
            fieldLabel: NonDiscriminationLabel.ND_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: NonDiscriminationLabel.ND_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: NonDiscriminationKey.ND_QUESTION_5,
            fieldLabel: NonDiscriminationLabel.ND_QUESTION_5
          }
        ]
      }
    ]
  }
];

export const childLaborTabQuestions = [
  {
    key: '1',
    label: ChildLaborLabel.CL_NON_DISCRIMINATION_1,
    kpiId: '408-1',
    items: [
      {
        question:
          'a. Operations considered to have significant risk for incidents of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ChildLaborKey.CL_QUESTION_1,
            fieldLabel: ChildLaborLabel.CL_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_2,
            tooltip:
              'In the context of the GRI Standards, a ‘young worker’ is defined as a person above the applicable minimum working age and younger than 18 years of age. Note that Disclosure 408-1 does not require quantitative reporting on child labor or the number of young workers. Rather, it asks for reporting on the operations and suppliers considered to have significant risk for incidents of child labor or young workers exposed to hazardous work.'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ChildLaborKey.CL_QUESTION_2,
            fieldLabel: ChildLaborLabel.CL_QUESTION_2
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: ChildLaborLabel.CL_NON_DISCRIMINATION_2,
    kpiId: '408-1',
    items: [
      {
        question:
          'a. Supplier considered to have significant risk for incidents of:',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ChildLaborKey.CL_QUESTION_3,
            fieldLabel: ChildLaborLabel.CL_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_2,
            tooltip:
              'In the context of the GRI Standards, a ‘young worker’ is defined as a person above the applicable minimum working age and younger than 18 years of age. Note that Disclosure 408-1 does not require quantitative reporting on child labor or the number of young workers. Rather, it asks for reporting on the operations and suppliers considered to have significant risk for incidents of child labor or young workers exposed to hazardous work.'
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ChildLaborKey.CL_QUESTION_4,
            fieldLabel: ChildLaborLabel.CL_QUESTION_4
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: ChildLaborLabel.CL_NON_DISCRIMINATION_3,
    kpiId: '408-1',
    items: [
      {
        question:
          'a. Operations considered to have significant risk for incidents of child labor either in terms of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ChildLaborKey.CL_QUESTION_5,
            fieldLabel: ChildLaborLabel.CL_QUESTION_5
          },
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ChildLaborKey.CL_QUESTION_6,
            fieldLabel: ChildLaborLabel.CL_QUESTION_6
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label: ChildLaborLabel.CL_NON_DISCRIMINATION_4,
    kpiId: '408-1',
    items: [
      {
        question:
          'a. Suppliers considered to have significant risk for incidents of child labor either in terms of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ChildLaborKey.CL_QUESTION_7,
            fieldLabel: ChildLaborLabel.CL_QUESTION_7
          },
          {
            fieldType: inputType.HEADING,
            heading: ChildLaborLabel.CL_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ChildLaborKey.CL_QUESTION_8,
            fieldLabel: ChildLaborLabel.CL_QUESTION_8
          }
        ]
      },
      {
        question:
          'b. Measures taken by the organization in the reporting period intended to contribute to the effective abolition of child labor',
        tooltip:
          'When reporting the measures taken, the organization can refer to the ILO ‘Tripartite Declaration of Principles Concerning Multinational Enterprises and Social Policy’ and Organisation for Economic Co-operation and Development (OECD) OECD Guidelines for Multinational Enterprises for further guidance.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ChildLaborKey.CL_QUESTION_9,
            fieldLabel: ChildLaborLabel.CL_QUESTION_9
          }
        ]
      }
    ]
  }
];

export const forcedLaborTabQuestions = [
  {
    key: '1',
    label: ForcedLaborLabel.FL_FORCED_LABOR_1,
    kpiId: '409-1',
    items: [
      {
        question:
          'a. Operations considered to have significant risk for incidents of forced or compulsory labor either in terms of: ',
        tooltip:
          'All work and service that is exacted from any person under the menace of any penalty and for which the said person has not offered herself or himself voluntarily Note 1: The most extreme examples of forced or compulsory labor are slave labor and bonded labor, but debts can also be used as a means of maintaining workers in a state of forced labor. Note 2: Indicators of forced labor include withholding identity papers, requiring compulsory deposits, and compelling workers, under threat of firing, to work extra hours to which they have not previously agreed.Note 3: This definition is based on International Labour Organization (ILO) Convention 29, ‘Forced Labour Convention’, 1930.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ForcedLaborLabel.FL_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ForcedLaborKey.FL_QUESTION_1,
            fieldLabel: ForcedLaborLabel.FL_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: ForcedLaborLabel.FL_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ForcedLaborKey.FL_QUESTION_2,
            fieldLabel: ForcedLaborLabel.FL_QUESTION_2
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: ForcedLaborLabel.FL_FORCED_LABOR_2,
    kpiId: '409-1',
    items: [
      {
        question:
          'a. Suppliers considered to have significant risk for incidents of forced or compulsory labor either in terms of: ',
        tooltip:
          'All work and service that is exacted from any person under the menace of any penalty and for which the said person has not offered herself or himself voluntarily Note 1: The most extreme examples of forced or compulsory labor are slave labor and bonded labor, but debts can also be used as a means of maintaining workers in a state of forced labor. Note 2: Indicators of forced labor include withholding identity papers, requiring compulsory deposits, and compelling workers, under threat of firing, to work extra hours to which they have not previously agreed. Note 3: This definition is based on International Labour Organization (ILO) Convention 29, ‘Forced Labour Convention’, 1930.',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: ForcedLaborLabel.FL_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ForcedLaborKey.FL_QUESTION_3,
            fieldLabel: ForcedLaborLabel.FL_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: ForcedLaborLabel.FL_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: ForcedLaborKey.FL_QUESTION_4,
            fieldLabel: ForcedLaborLabel.FL_QUESTION_4
          }
        ]
      },
      {
        question:
          'b. Measures taken by the organization in the reporting period intended to contribute to the elimination of all forms of forced or compulsory labor.',
        tooltip:
          'When reporting the measures taken, the organization can refer to the ILO ‘Tripartite Declaration of Principles Concerning Multinational Enterprises and Social Policy’ and Organisation for Economic Co-operation and Development (OECD) OECD Guidelines for Multinational Enterprises for further guidance',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: ForcedLaborKey.FL_QUESTION_5,
            fieldLabel: ForcedLaborLabel.FL_QUESTION_5
          }
        ]
      }
    ]
  }
];

export const occupationalHealthAndSafetyTabQuestions = [
  {
    key: '1',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_1,
    kpiId: '403-1',
    items: [
      {
        question:
          'a. A statement of whether an occupational health and safety management system has been implemented: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_1
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_1,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_2
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_2,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_2
          }
        ]
      },
      {
        question:
          'b. A description of the scope of workers, activities, and workplaces covered by the occupational health and safety management system, and an explanation of whether and, if so, why any workers, activities, or workplaces are not covered.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_3,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_2,
    kpiId: '403-2',
    items: [
      {
        question:
          'a. A description of the processes used to identify work-related hazards and assess risks on a routine and non-routine basis, and to apply the hierarchy of controls in order to eliminate hazards and minimize risks, including: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_4,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_4
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_5,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_5
          }
        ]
      },
      {
        question:
          'b. A description of the processes for workers to report work-related hazards and hazardous situations, and an explanation of how workers are protected against reprisals.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_6,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_6
          }
        ]
      },
      {
        question:
          'c. A description of the policies and processes for workers to remove themselves from work situations that they believe could cause injury or ill health, and an explanation of how workers are protected against reprisals.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_8,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_8
          }
        ]
      },
      {
        question:
          'd. A description of the processes used to investigate work-related incidents, including the processes to identify hazards and assess risks relating to the incidents, to determine corrective actions using the hierarchy of controls, and to determine improvements needed in the occupational health and safety management system.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_9,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_9
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_3,
    kpiId: '403-3',
    items: [
      {
        question:
          'a. A description of the occupational health services’ functions that contribute to the identification and elimination of hazards and minimization of risks, and an explanation of how the organization ensures the quality of these services and facilitates workers’ access to them.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_10,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_10
          }
        ]
      }
    ]
  },
  {
    key: '4',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_4,
    kpiId: '403-4',
    items: [
      {
        question:
          'a. A description of the processes for worker participation and consultation in the development, implementation, and evaluation of the occupational health and safety management system, and for providing access to and communicating relevant information on occupational health and safety to workers.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_11,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_11
          }
        ]
      },
      {
        question:
          'b. Where formal joint management–worker health and safety committees exist, a description of their responsibilities, meeting frequency, decision-making authority, and whether and, if so, why any workers are not represented by these committees.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_12,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_12
          }
        ]
      }
    ]
  },
  {
    key: '5',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_5,
    kpiId: '403-5',
    items: [
      {
        question:
          'a. A description of any occupational health and safety training provided to workers, including generic training as well as training on specific work-related hazards, hazardous activities, or hazardous situations',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_13,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_13
          }
        ]
      }
    ]
  },
  {
    key: '6',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_6,
    kpiId: '403-6',
    items: [
      {
        question:
          'a. An explanation of how the organization facilitates workers’ access to non-occupational medical and healthcare services, and the scope of access provided.',
        tooltip:
          'Achieving universal health coverage, including financial risk protection. access to quality essential healthcare services. and access to safe, effective, quality and affordable essential medicines and vaccines for all, is one of the targets of the UN Sustainable Development Goals',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_14,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_14
          }
        ]
      },
      {
        question:
          'b. A description of any voluntary health promotion services and programs offered to workers to address major non-work-related health risks, including the specific health risks addressed, and how the organization facilitates workers’ access to these services and programs.',
        tooltip:
          'Ensuring healthy lives and promoting wellbeing for all at all ages is one of the UN Sustainable Development Goals (Goal 3). This goal includes targets such as reducing premature mortality from non-communicable diseases through prevention and treatment, and promoting mental health and wellbeing. strengthening the prevention and treatment of substance abuse, including narcotic drug abuse and harmful consumption of alcohol. ensuring universal access to sexual and reproductive healthcare services. and ending epidemics of AIDS, tuberculosis, malaria, and neglected tropical diseases, and combating hepatitis, water-borne diseases, and other communicable diseases.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_15,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_15
          }
        ]
      }
    ]
  },
  {
    key: '7',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_7,
    kpiId: '403-7',
    items: [
      {
        question:
          'a. A description of the organization’s approach to preventing or mitigating significant negative occupational health and safety impacts that are directly linked to its operations, products or services by its business relationships, and the related hazards and risks.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_16,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_16
          }
        ]
      }
    ]
  },
  {
    key: '8',
    label:
      OccupationalHealthAndSafetyLabel.OHS_OCCUPATIONAL_HEALTH_AND_SAFETY_8,
    kpiId: '403-8',
    items: [
      {
        question:
          'a. If the organization has implemented an occupational health and safety management system based on legal requirements and/or recognized standards/guidelines: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_17,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_17
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_6
          },
          {
            fieldType: inputType.HEADING_5,
            heading: OccupationalHealthAndSafetyLabel.OHS_QUESTION_18
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_18
          },
          {
            fieldType: inputType.HEADING_5,
            heading: OccupationalHealthAndSafetyLabel.OHS_QUESTION_19
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_19
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_7
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_20,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_20
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_8
          },
          {
            fieldType: inputType.HEADING_5,
            heading: OccupationalHealthAndSafetyLabel.OHS_QUESTION_21
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_21
          },
          {
            fieldType: inputType.HEADING_5,
            heading: OccupationalHealthAndSafetyLabel.OHS_QUESTION_22
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_22
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_23,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_23
          },
          {
            fieldType: inputType.HEADING,
            heading: OccupationalHealthAndSafetyLabel.OHS_HEADING_10
          },
          {
            fieldType: inputType.HEADING_5,
            heading: OccupationalHealthAndSafetyLabel.OHS_QUESTION_24
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_24
          },
          {
            fieldType: inputType.HEADING_5,
            heading: OccupationalHealthAndSafetyLabel.OHS_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_25
          }
        ]
      },
      {
        question:
          'b. Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_26,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_26
          }
        ]
      },
      {
        question:
          'c. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: OccupationalHealthAndSafetyKey.OHS_QUESTION_27,
            fieldLabel: OccupationalHealthAndSafetyLabel.OHS_QUESTION_27
          }
        ]
      }
    ]
  }
];

export const workRelatedInjuriesTabQuestions = [
  {
    key: '1',
    label: WorkRelatedInjuriesLabel.WRI_WORK_RELATED_INJURIES_1,
    kpiId: '403-9',
    items: [
      {
        question:
          'i. The number of fatalities as a result of work-related injury.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_1,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_1
          }
        ]
      },
      {
        question: 'The rate of fatalities as a result of work-related injury.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_3,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_2,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_2
          }
        ]
      },
      {
        question:
          'ii. The number of high-consequence work-related injuries (excluding fatalities).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_4,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_4
          }
        ]
      },
      {
        question:
          'The rate of high-consequence work-related injuries (excluding fatalities).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_5,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_6,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_6
          }
        ]
      },
      {
        question: 'iii. The number of recordable work-related injuries.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_7,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_7
          }
        ]
      },
      {
        question: 'The rate of recordable work-related injuries.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_8,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_9,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_9
          }
        ]
      },
      {
        question: 'iv. The main types of work-related injury.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_10,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_10
          }
        ]
      },
      {
        question: 'v. The number of hours worked - Employees',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_11,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_11
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_11_1,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_11_1,
            tooltip:
              'Note: Put the calculated value for Number of hours worked or calculate by using following formula: Total Number of Employees * 2000'
          }
        ]
      },
      {
        question: 'The number of hours worked - Contractors',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_12,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_12
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_12_1,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_12_1,
            tooltip:
              'Note: Put the calculated value for Number of hours worked or calculate by using following formula: Total Number of Employees * 2000'
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: WorkRelatedInjuriesLabel.WRI_WORK_RELATED_INJURIES_2,
    kpiId: '403-9',
    items: [
      {
        question:
          'i. The number of fatalities as a result of work-related injury.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_13,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_13
          }
        ]
      },
      {
        question: 'The rate of fatalities as a result of work-related injury.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_14,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_14
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_15,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_15
          }
        ]
      },
      {
        question:
          'ii. The number of high-consequence work-related injuries (excluding fatalities).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_16,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_16
          }
        ]
      },
      {
        question:
          'The rate of high-consequence work-related injuries (excluding fatalities).',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_17,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_17
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_18,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_18
          }
        ]
      },
      {
        question: 'iii. The number of recordable work-related injuries.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_19,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_19
          }
        ]
      },
      {
        question: 'The rate of recordable work-related injuries.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_20,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_20
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_21,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_21
          }
        ]
      },
      {
        question: 'iv. The main types of work-related injury.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_22,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_22
          }
        ]
      },
      {
        question: 'v. The number of hours worked - Employees',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_23,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_23
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_24,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_24,
            tooltip:
              'Note: Put the calculated value for Number of hours worked or calculate by using following formula: Total Number of Employees * 2000'
          }
        ]
      },
      {
        question: 'The number of hours worked - Workers',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_25,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_25
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_26,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_26,
            tooltip:
              'Note: Put the calculated value for Number of hours worked or calculate by using following formula: Total Number of Employees * 2000'
          }
        ],
        tooltip:
          'This is for workers and contract-based workers'
      }
    ]
  },
  {
    key: '3',
    label: WorkRelatedInjuriesLabel.WRI_WORK_RELATED_INJURIES_3,
    kpiId: '403-9',
    items: [
      {
        question: 'i. How these hazards have been determined.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_27,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_27
          }
        ]
      },
      {
        question:
          'ii. which of these hazards have caused or contributed to high-consequence injuries during the reporting period.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_28,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_28
          }
        ]
      },
      {
        question:
          'iii. Actions taken or underway to eliminate these hazards and minimize risks using the hierarchy of controls.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_29,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_29
          }
        ]
      },
      {
        question:
          'd. Any actions taken or underway to eliminate other work-related hazards and minimize risks using the hierarchy of controls.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_30,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_30
          }
        ]
      },
      {
        question:
          'e. Whether the rates have been calculated based on 200,000 or 1,000,000 hours worked.',
        tooltip: 'It should be 200,000 or 1,000,000 hours worked.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_31,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_31
          }
        ]
      },
      {
        question:
          'f. Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_32,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_32
          }
        ]
      },
      {
        question:
          'g. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedInjuriesKey.WRI_QUESTION_33,
            fieldLabel: WorkRelatedInjuriesLabel.WRI_QUESTION_33
          }
        ]
      }
    ]
  }
];

export const workRelatedIllHealthTabQuestions = [
  {
    key: '1',
    label: WorkRelatedIllHealthLabel.WRIH_WORK_RELATED_ILL_HEALTH_1,
    kpiId: '403-10',
    items: [
      {
        question:
          'i. The number of fatalities as a result of work-related ill health.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_1,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_1
          }
        ]
      },
      {
        question:
          'ii. The number of cases of recordable work-related ill health.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_2,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_2
          }
        ]
      },
      {
        question: 'iii. The main types of work-related ill health.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_3,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_3
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: WorkRelatedIllHealthLabel.WRIH_WORK_RELATED_ILL_HEALTH_2,
    kpiId: '403-10',
    items: [
      {
        question:
          'i. The number of fatalities as a result of work-related ill health.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_4,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_4
          }
        ]
      },
      {
        question:
          ' ii. The number of cases of recordable work-related ill health.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_5,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_5
          }
        ]
      },
      {
        question: 'iii. The main types of work-related ill health.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_6,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_6
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: WorkRelatedIllHealthLabel.WRIH_WORK_RELATED_ILL_HEALTH_3,
    kpiId: '403-10',
    items: [
      {
        question: 'i. How these hazards have been determined.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_7,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_7
          }
        ]
      },
      {
        question:
          'ii. Which of these hazards have caused or contributed to cases of ill health during the reporting period.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_8,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_8
          }
        ]
      },
      {
        question:
          'iii. Actions taken or underway to eliminate these hazards and minimize risks using the hierarchy of controls.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_9,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_9
          }
        ]
      },
      {
        question:
          'd. Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_10,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_10
          }
        ]
      },
      {
        question:
          'e. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: WorkRelatedIllHealthKey.WRIH_QUESTION_11,
            fieldLabel: WorkRelatedIllHealthLabel.WRIH_QUESTION_11
          }
        ]
      }
    ]
  }
];

export const trainingAndEducationTabQuestions = [
  {
    key: '1',
    label: TrainingAndEducationLabel.TAE_TRAINING_AND_EDUCATION_1,
    kpiId: '404-1',
    items: [
      {
        question: 'Average hours of training per year per employee',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: TrainingAndEducationKey.TAE_QUESTION_1,
            fieldLabel: TrainingAndEducationLabel.TAE_QUESTION_1
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: TrainingAndEducationLabel.TAE_TRAINING_AND_EDUCATION_2,
    kpiId: '404-2',
    items: [
      {
        question:
          'Programs for upgrading employee skills and transition assistance programs',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: TrainingAndEducationKey.TAE_QUESTION_2,
            fieldLabel: TrainingAndEducationLabel.TAE_QUESTION_2
          }
        ]
      }
    ]
  },
  {
    key: '3',
    label: TrainingAndEducationLabel.TAE_TRAINING_AND_EDUCATION_3,
    kpiId: '404-3',
    items: [
      {
        question:
          'Percentage of employees receiving regular performance and career development reviews',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: TrainingAndEducationKey.TAE_QUESTION_3,
            fieldLabel: TrainingAndEducationLabel.TAE_QUESTION_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              TrainingAndEducationKey.TAE_QUESTION_5,
            fieldLabel:
              TrainingAndEducationLabel.TAE_QUESTION_5
          },
          {
            fieldType: inputType.NUMBER,
            fieldName:
              TrainingAndEducationKey.TAE_QUESTION_6,
            fieldLabel:
              TrainingAndEducationLabel.TAE_QUESTION_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: TrainingAndEducationKey.TAE_QUESTION_4,
            fieldLabel: TrainingAndEducationLabel.TAE_QUESTION_4
          }
        ]
      }
    ]
  }
];

export const supplierSocialAssessmentTabQuestions = [
  {
    key: '1',
    label: SupplierSocialAssessmentLabel.SSA_SUPPLIER_SOCIAL_ASSESSMENT_1,
    kpiId: '414-1',
    items: [
      {
        question:
          'a. Percentage of new suppliers that were screened using social criteria',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_1,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_2,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_2
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: SupplierSocialAssessmentLabel.SSA_SUPPLIER_SOCIAL_ASSESSMENT_2,
    kpiId: '414-2',
    items: [
      {
        question: 'a. Number of suppliers assessed for social impacts',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_3,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_3
          }
        ]
      },
      {
        question:
          'b. Number of suppliers identified as having significant actual and potential negative social impacts',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_4,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_4
          }
        ]
      },
      {
        question:
          'c. Significant actual and potential negative social impacts identified in the supply chain. ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_5,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_5
          }
        ]
      },
      {
        question:
          'd. Percentage of suppliers identified as having significant actual and potential negative social impacts with which improvements were agreed upon as a result of assessment. ',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_6,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_6
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_7,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_7
          }
        ]
      },
      {
        question:
          'e. Percentage of suppliers identified as having significant actual and potential negative social impacts with which relationships were terminated as a result of assessment, and why.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_8,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_8
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_9,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_9
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SupplierSocialAssessmentKey.SSA_QUESTION_10,
            fieldLabel: SupplierSocialAssessmentLabel.SSA_QUESTION_10
          }
        ]
      }
    ]
  }
];

export const customerHealthAndSafetyTabQuestions = [
  {
    key: '1',
    label: CustomerHealthAndSafetyLabel.CHAS_CUSTOMER_HEALTH_AND_SAFETY_1,
    kpiId: '416-1',
    items: [
      {
        question:
          'a. Percentage of significant product and service categories for which health and safety impacts are assessed for improvement.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerHealthAndSafetyKey.CHAS_QUESTION_1,
            fieldLabel: CustomerHealthAndSafetyLabel.CHAS_QUESTION_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerHealthAndSafetyKey.CHAS_QUESTION_2,
            fieldLabel: CustomerHealthAndSafetyLabel.CHAS_QUESTION_2
          }
        ]
      }
    ]
  },
  {
    key: '2',
    label: CustomerHealthAndSafetyLabel.CHAS_CUSTOMER_HEALTH_AND_SAFETY_2,
    kpiId: '416-2',
    items: [
      {
        question:
          'a. Total number of incidents of non-compliance with regulations and/or voluntary codes concerning the health and safety impacts of products and services within the reporting period, by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: CustomerHealthAndSafetyLabel.CHAS_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerHealthAndSafetyKey.CHAS_QUESTION_3,
            fieldLabel: CustomerHealthAndSafetyLabel.CHAS_QUESTION_3
          },
          {
            fieldType: inputType.HEADING,
            heading: CustomerHealthAndSafetyLabel.CHAS_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerHealthAndSafetyKey.CHAS_QUESTION_4,
            fieldLabel: CustomerHealthAndSafetyLabel.CHAS_QUESTION_4
          },
          {
            fieldType: inputType.HEADING,
            heading: CustomerHealthAndSafetyLabel.CHAS_HEADING_3
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerHealthAndSafetyKey.CHAS_QUESTION_5,
            fieldLabel: CustomerHealthAndSafetyLabel.CHAS_QUESTION_5
          }
        ]
      },
      {
        question:
          'b. If the organization has not identified any non-compliance with regulations and/or voluntary codes, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: CustomerHealthAndSafetyKey.CHAS_QUESTION_6,
            fieldLabel: CustomerHealthAndSafetyLabel.CHAS_QUESTION_6
          }
        ]
      }
    ]
  }
];

export const customerPrivacyTabQuestions = [
  {
    key: '1',
    label: CustomerPrivacyLabel.CP_CUSTOMER_PRIVACY_1,
    kpiId: '418-1',
    items: [
      {
        question:
          'a. Total number of substantiated complaints received concerning breaches of customer privacy, categorized by: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: CustomerPrivacyLabel.CP_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerPrivacyKey.CP_QUESTION_1,
            fieldLabel: CustomerPrivacyLabel.CP_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: CustomerPrivacyLabel.CP_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerPrivacyKey.CP_QUESTION_2,
            fieldLabel: CustomerPrivacyLabel.CP_QUESTION_2
          }
        ]
      },
      {
        question:
          'b. Total number of identified leaks, thefts, or losses of customer data.',
        field: [
          {
            fieldType: inputType.NUMBER,
            fieldName: CustomerPrivacyKey.CP_QUESTION_3,
            fieldLabel: CustomerPrivacyLabel.CP_QUESTION_3
          }
        ]
      },
      {
        question:
          'c. If the organization has not identified any substantiated complaints, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: CustomerPrivacyKey.CP_QUESTION_4,
            fieldLabel: CustomerPrivacyLabel.CP_QUESTION_4
          }
        ]
      }
    ]
  }
];

export const socioeconomicComplianceTabQuestions = [
  {
    key: '1',
    label: SocioeconomicComplianceLabel.SC_SOCIOECONOMIC_COMPLIANCE_1,
    kpiId: '419-1',
    items: [
      {
        question:
          'a. Significant fines and non-monetary sanctions for non-compliance with laws and/or regulations in the social and economic area in terms of: ',
        field: [
          {
            fieldType: inputType.HEADING,
            heading: SocioeconomicComplianceLabel.SC_HEADING_1
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SocioeconomicComplianceKey.SC_QUESTION_1,
            fieldLabel: SocioeconomicComplianceLabel.SC_QUESTION_1
          },
          {
            fieldType: inputType.HEADING,
            heading: SocioeconomicComplianceLabel.SC_HEADING_2
          },
          {
            fieldType: inputType.NUMBER,
            fieldName: SocioeconomicComplianceKey.SC_QUESTION_2,
            fieldLabel: SocioeconomicComplianceLabel.SC_QUESTION_2
          },
          {
            fieldType: inputType.HEADING,
            heading: SocioeconomicComplianceLabel.SC_HEADING_3
          },
          {
            fieldType: inputType.TEXTAREA,
            fieldName: SocioeconomicComplianceKey.SC_QUESTION_3,
            fieldLabel: SocioeconomicComplianceLabel.SC_QUESTION_3
          }
        ]
      },
      {
        question:
          'b. If the organization has not identified any non-compliance with laws and/or regulations, a brief statement of this fact is sufficient.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: SocioeconomicComplianceKey.SC_QUESTION_4,
            fieldLabel: SocioeconomicComplianceLabel.SC_QUESTION_4
          }
        ]
      },
      {
        question:
          'c. The context against which significant fines and non-monetary sanctions were incurred.',
        field: [
          {
            fieldType: inputType.TEXTAREA,
            fieldName: SocioeconomicComplianceKey.SC_QUESTION_5,
            fieldLabel: SocioeconomicComplianceLabel.SC_QUESTION_5
          }
        ]
      }
    ]
  }
];
